import { BrandResearchKeyword } from '../types/brandResearch';

const brandRiskNegativeTerms = new Set([
  'apokalypse',
  'bunker',
  'counterfeit',
  'doomsday',
  'fake',
  'fälschung',
  'hamsterkauf',
  'illegal',
  'krise',
  'krisenvorsorge',
  'notfall',
  'notvorrat',
  'plagiat',
  'prepper',
  'survival',
  'weltuntergang',
]);

const brandRiskNegativePhrases = [
  'black market',
  'doomsday prepper',
  'gefälscht',
  'gefälschte',
  'kriegsvorrat',
  'not ration',
  'notvorrat',
  'prepper image',
  'survival ration',
];

const tokenize = (value: string): string[] => (
  value
    .toLowerCase()
    .split(/[^\p{L}\p{N}_]+/u)
    .filter(Boolean)
);

export const isBrandRiskNegativeKeyword = (keyword: string): boolean => {
  const normalized = keyword.trim().toLowerCase();
  if (!normalized) return false;

  if (tokenize(normalized).some((token) => brandRiskNegativeTerms.has(token))) {
    return true;
  }

  return brandRiskNegativePhrases.some((phrase) => normalized.includes(phrase));
};

export const filterBrandRiskNegativeKeywords = (
  keywords: BrandResearchKeyword[] = [],
): BrandResearchKeyword[] => (
  keywords.filter((keyword) => isBrandRiskNegativeKeyword(keyword.keyword || ''))
);
